import { render, staticRenderFns } from "./StarsRatingInput.vue?vue&type=template&id=16f147d6&scoped=true"
import script from "./StarsRatingInput.vue?vue&type=script&lang=js"
export * from "./StarsRatingInput.vue?vue&type=script&lang=js"
import style0 from "./StarsRatingInput.vue?vue&type=style&index=0&id=16f147d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f147d6",
  null
  
)

export default component.exports